import React, { Component } from 'react';

// parts
import CardTitlePart from '../../../parts/CardTitlePart';
import NumOfPager from '../../../parts/NumOfPager';
import CardBannerPart from '../../../parts/CardBannerPart';
import HtmlPart from '../../../parts/HtmlPart';

// Layout
import TextCTA from '../../../layout/buttons/TextCTA';

//
import EmailForm from './EmailForm';
import FacebookForm from './FacebookForm';
import TwitterForm from './TwitterForm';
import MessageTextArea from './MessageTextArea';
import Confirmation from './Confirmation';

const STAGES = [
  'intro',
  'form',
  'message',
  'confirmation'
];

class RecommendAFriendCard extends Component {


  constructor(props) {
    super(props);
    this.state = {
      stage: 'intro',
      mode: 'email',
      userEmail: '',
      friendEmail: '',
      message: 'Hi, just wanted to tell you about Sofology!',
    };
    this.handleUserEmailChange = this.handleUserEmailChange.bind(this);
    this.handleFriendEmailChange = this.handleFriendEmailChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);

  }

  renderStage() {
    const { stage, message } = this.state;
    const { headerImage, headerImageAltText, confirmationText } = this.props;

    return [
      stage !== 'intro' ? this.renderModeSelect() : null,
      {
        intro: <CardBannerPart imageSrc={headerImage} imageAltText={headerImageAltText}/>,
        form: this.renderShareForm(),
        message: <MessageTextArea text={message} onTextChange={this.handleMessageChange}/>,
        confirmation: <Confirmation text={confirmationText} />
      }[stage]
    ];
  }

  renderModeSelect() {
    const { mode } = this.state;
    return (
      <nav className="c-tab-bar  c-tab-bar__tab" style={{ width: '100%', height: '50px' }}>
        <button
          className={`c-tab-bar__tab${mode === 'email' ? '--active': ''}  c-tab-bar__tab--email`}
          onClick={() => this.handleModeChange('email')}
        >
          <i className="sa sa-mail"></i>
        </button>
        <button
          className={`c-tab-bar__tab${mode === 'facebook' ? '--active': ''}`}
          onClick={() => this.handleModeChange('facebook')}
        >
          <i className="sa sa-facebook"></i>
        </button>
        <button
          className={`c-tab-bar__tab${mode === 'twitter' ? '--active': ''}`}
          onClick={() => this.handleModeChange('twitter')}
        >
          <i className="sa sa-twitter"></i>
        </button>
      </nav>
    );
  }

  renderShareForm() {
    const { userEmail, friendEmail } = this.state;
    return {
      email: <EmailForm
        userEmail={userEmail}
        onUserEmailChange={this.handleUserEmailChange}
        friendEmail={friendEmail}
        onFriendEmailChange={this.handleFriendEmailChange}
      />,
      facebook: <FacebookForm />,
      twitter: <TwitterForm />
    }[this.state.mode] || null;
  }

  handleModeChange(mode) {
    if(this.state.mode === mode) return;
    this.setState({ mode, stage: 'form' });
  }

  handleUserEmailChange(e) {
    this.setState({ userEmail: e.target.value })
  }

  handleFriendEmailChange(e) {
    this.setState({ friendEmail: e.target.value })
  }

  handleMessageChange(e) {
    this.setState({ message: e.target.value })
  }

  handleNextClick() {
    const { stage } = this.state;
    const nextStages = {
      intro: 'form',
      form: 'message',
      message: 'confirmation',
      confirmation: 'intro'
    };
    this.setState({ stage: nextStages[stage] });
  }

  render() {
    const { title, bodyText } = this.props;
    return (
      <div>
        <CardTitlePart title={title} />
        <div className="c-event-feed__card__card-pager">
          <NumOfPager numPages={STAGES.length} selected={STAGES.indexOf(this.state.stage)} />
        </div>

        {this.renderStage()}

        <section className="c-event-feed__card__splitter  u-flex  u-flex-justify-end" style={{ width: '100%' }}>
          <TextCTA text="Next" type="confirm" onBtnClick={this.handleNextClick} />
        </section>

        <section className="c-event-feed__card  c-html-part  u-padding-small  u-flex  u-flex-justify-start">
          <HtmlPart htmlString={bodyText} />
        </section>

      </div>
    );
  }

}

export default RecommendAFriendCard;



// WEBPACK FOOTER //
// ./src/cards/templates/RecommendAFriendCard/index.js